import { Modules } from '../../../util/modules'
import { RouteConfig } from 'vue-router'
import { requireAuthAndLocation } from '../../auth'

// Invoices App
const InvoiceEditor = () =>  import('@/pmd/pages/payments/payment-products/InvoiceEditor.vue')
const InvoiceTemplateEditor = () =>  import('@/pmd/pages/payments/payment-products/InvoiceTemplateEditor.vue')
const RecurringInvoiceEditor = () =>  import('@/pmd/pages/payments/payment-products/RecurringInvoiceEditor.vue')
const ListInvoices = () =>  import('@/pmd/pages/payments/payment-products/ListInvoices.vue')
const ListRecurringInvoices = () =>  import('@/pmd/pages/payments/payment-products/ListRecurringInvoices.vue')
const ListTemplates = () =>  import('@/pmd/pages/payments/payment-products/ListTemplates.vue')
const InvoiceSettingsApp = () => import('@/pmd/pages/payments/payment-products/InvoiceSettingsApp.vue')
const ImportInvoices = () => import('@/pmd/pages/payments/payment-products/ImportInvoices.vue')

export const invoicesRoutes: RouteConfig[] = [
    {
        path: 'payments/invoices',
        name: 'payment-products-list-invoices',
        component: ListInvoices,
        beforeEnter: requireAuthAndLocation,
        meta: {
            translations: [Modules.Payments],
        },
    },
    {
        path: 'payments/recurring-templates',
        name: 'payment-products-list-recurring-invoices',
        component: ListRecurringInvoices,
        beforeEnter: requireAuthAndLocation,
        meta: {
            translations: [Modules.Payments],
        },
    },
    {
        path: 'payments/invoices/import',
        name: 'payment-products-import-invoices',
        component: ImportInvoices,
        beforeEnter: requireAuthAndLocation,
        meta: {
            hideSideBar: true,
            hideTopBar: true,
            translations: [Modules.Payments],
        },
    },
    {
        path: 'payments/invoices/:invoiceId',
        name: 'payment-products-invoice-editor',
        component: InvoiceEditor,
        beforeEnter: requireAuthAndLocation,
        meta: {
            hideSideBar: true,
            hideTopBar: true,
            translations: [Modules.Payments],
        },
    },
    {
        path: 'payments/invoice-templates/:templateId',
        name: 'payment-products-invoice-template-editor',
        component: InvoiceTemplateEditor,
        beforeEnter: requireAuthAndLocation,
        meta: {
            hideSideBar: true,
            hideTopBar: true,
            translations: [Modules.Payments],
        },
    },
    {
        path: 'payments/invoice-templates',
        name: 'invoice-templates',
        component: ListTemplates,
        beforeEnter: requireAuthAndLocation,
        meta: {
            hideSideBar: false,
            hideTopBar: false,
            translations: [Modules.Payments],
        },
    },
    {
        path: 'payments/recurring-templates/v2/:scheduleId',
        name: 'payment-products-recurring-invoice-editor',
        component: RecurringInvoiceEditor,
        beforeEnter: requireAuthAndLocation,
        meta: {
            hideSideBar: true,
            hideTopBar: true,
            translations: [Modules.Payments],
        },
    },
    {
        path: 'payments/invoice/settings',
        name: 'invoice-settings',
        component: InvoiceSettingsApp,
        beforeEnter: requireAuthAndLocation,
        meta: {
          hideSideBar: false,
          hideTopBar: false,
          translations: [Modules.Payments],
        },
    },
]
